import { z } from 'zod/mini'

export const changePaymentMethodSuccessSearchSchema = z.object({
  setup_intent: z.string(),
  setup_intent_client_secret: z.string(),
  redirect_status: z.enum(['succeeded', 'failed']),
})
